Vendd.Scripts.load(function () {

    var $wrapper = $('.x-partner-list');

    if ($wrapper.length < 1)
        return;

    var carouselStoresOpts = {
        slidesPerRow: 4,
        rows: 2,
        infinite: false,
        draggable: false,
        arrows: false,
        dots: true,
        responsive: [{
            breakpoint: 960,
            settings: {
                slidesPerRow: 3,
                rows: 2,
            }

        }, {
            breakpoint: 768,
            settings: {
                slidesPerRow: 2,
                rows: 2,
            }

        }]
    };

    $wrapper.each(function () {
        var $partnerList = $(this);
        if ($partnerList.closest('.x-store-locator').length < 1) {
            var $boxes = $('.x-partner-box', $partnerList);
            initAccordion($boxes);

            if ($partnerList.hasClass('x-slider')) {
                var $sliderList = $('> ul', $partnerList);

                initSlider($sliderList);

                 $(window).resize($.debounce(500, function () {
                    initSlider($sliderList);
                }));

                $sliderList.on('destroy', function (event, slick, direction) {
                    initAccordion($boxes);
                });
            }
        }
    }); 

    function initAccordion($boxes) {    
        $boxes.on('click', '.js-info-toggle-btn', function (e) {
            var $this = $(this);
            var partner = $this.closest('.x-partner-box');
            var iconOpen = $this.data('open-icon');
            var iconClose = $this.data('close-icon');
            prevOpened = $this.closest('.x-partner-list').find('.x-partner-box.opened');
            if (!partner.hasClass('opened')) {
                prevOpened.find('.js-info-toggle-btn').toggleClass(iconOpen + ' ' + iconClose);
                prevOpened.removeClass('opened');
            }
            partner.toggleClass('opened');
            $this.toggleClass(iconOpen + ' ' + iconClose);
        });
    }

    function initSlider($sliderList) {
        if ($(window).width() < 480) {
            if ($sliderList.hasClass('slick-initialized')) {
                $sliderList.slick('unslick');
            }
        } else {
            if (!$sliderList.hasClass('slick-initialized')) {
                $sliderList.slick(carouselStoresOpts);
            }
        }
    }

});